import type { FaireProductEntity } from "../../entity_types/product";

export const p_g6ajuaz7ws: FaireProductEntity = {
  token: "p_g6ajuaz7ws",
  type: "product",
  name: "Rye Short Tumbler Glass / Old Fashioned Glass / Set of 2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/e064968eb429274db3699702f8531910fd109812574df29807c467323503c3fd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0c7cf8b2c5fdef8af3ec935abfa9fd77eb9a32fcf021b49e0808623c20e9ec69.jpeg",
    "https://cdn.faire.com/fastly/c469cae0270db3eae06b7fadb19617e21cb176f7836797213241f44388903789.jpeg",
    "https://cdn.faire.com/fastly/f41e9bd6f2a772c0a93b8b4a663856a8e2c82e94dfce4a58620f9e34627c676b.jpeg",
    "https://cdn.faire.com/fastly/178b2d25aaad1ff15ee39b6c9cc5a329b5e8304a834755ad4b03070e8f61f633.jpeg",
    "https://cdn.faire.com/fastly/b0d3f3f9d2b68e67365d2d8007d46607040f4445c769caca5002a4684805d0b2.jpeg",
    "https://cdn.faire.com/fastly/2f88c78ed97ab393de926bec254613aeb953cb59fc64fd8a7cf2e63ed306c7c7.jpeg",
    "https://cdn.faire.com/fastly/436c06a9d5c8764c84f6c0dcab645b9e04e38b560bc55cf7caae127fba64d5b2.jpeg",
  ],
  priceDollars: 25,
  description:
    'RYE glassware range has been designed to elevate the drinking experience, whether it is water, beer, wine or a meticulously mixed cocktail. The glasses are skilfully hand crafted from a robust borosilicate glass. The range is well-proportioned, graphic in form, and the subtle accent of coloured glass elevates the drink whilst still allowing you to appreciate the shade of the drink.\n\nThis size is perfect for sipping your favourite whisky plain, on the rocks or as an Old Fashioned.\n\n• Packed as a set of 2.\n• Size: D 8.5cm x H 7cm / D 3.4" x H 2.8"\n• Capacity: 295ml / 10 fl oz\n\n• Colour: clear + smoke\n\n• Perfect addition to Autumn / Fall / Christmas / Holiday / Thanksgiving season collection!',
  tags: [],
  msrpDollars: 50,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:29.282Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
